import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your inquiry. The PuttLab team will be in touch shortly.');
  };
  return <div className="w-full pt-24 bg-brand-cream-light min-h-screen" data-id="element-482">
      <div className="max-w-7xl mx-auto px-6 py-24" data-id="element-483">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-484">
          {/* Info Side */}
          <div className="lg:col-span-5" data-id="element-485">
            <ScrollReveal data-id="element-486">
              <SectionHeading eyebrow="Start a Project" title="Let's create something unforgettable." subtitle="Tell us about your space, your vision, and what kind of experience you want to build." data-id="element-487" />

              <div className="mt-16 space-y-8 font-body" data-id="element-488">
                <div data-id="element-489">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-490">
                    Email
                  </h4>
                  <a href="mailto:hello@puttlabstudio.com" className="text-xl text-brand-green-deep hover:text-brand-gold transition-colors" data-id="element-491">
                    hello@puttlabstudio.com
                  </a>
                </div>
                <div data-id="element-492">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-493">
                    Location
                  </h4>
                  <p className="text-xl text-brand-green-deep" data-id="element-494">
                    Toronto
                    <br data-id="element-495" />
                    <span className="text-brand-stone text-base" data-id="element-496">
                      Available for global projects
                    </span>
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Form Side */}
          <div className="lg:col-span-7" data-id="element-497">
            <ScrollReveal delay={0.2} data-id="element-498">
              <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-brand-stone/10" data-id="element-499">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-500">
                  <div data-id="element-501">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-502">
                      Name
                    </label>
                    <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-503" />
                  </div>
                  <div data-id="element-504">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-505">
                      Company (Optional)
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-506" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-507">
                  <div data-id="element-508">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-509">
                      Email
                    </label>
                    <input type="email" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-510" />
                  </div>
                  <div data-id="element-511">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-512">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-513" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-514">
                  <div data-id="element-515">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-516">
                      Property Type
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-517">
                      <option data-id="element-518">Residential</option>
                      <option data-id="element-519">Resort / Hotel</option>
                      <option data-id="element-520">Commercial Development</option>
                      <option data-id="element-521">Event / Activation</option>
                      <option data-id="element-522">Other</option>
                    </select>
                  </div>
                  <div data-id="element-523">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-524">
                      Budget Range
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-525">
                      <option data-id="element-526">$10k - $25k</option>
                      <option data-id="element-527">$25k - $50k</option>
                      <option data-id="element-528">$50k - $100k</option>
                      <option data-id="element-529">$100k+</option>
                    </select>
                  </div>
                </div>

                <div className="mb-6" data-id="element-530">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-531">
                    Location (City, State/Prov)
                  </label>
                  <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-532" />
                </div>

                <div className="mb-8" data-id="element-533">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-534">
                    Notes / Vision
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body resize-none" placeholder="Tell us about the space and what you're hoping to achieve..." data-id="element-535"></textarea>
                </div>

                <Button type="submit" variant="dark" className="w-full" data-id="element-536">
                  Submit Inquiry
                </Button>
              </form>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </div>;
}